<div class="chat-container">
    <iframe [src]="chatUrl | safe" height="100%" width="100%"></iframe>
</div>